.root {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--terminal-bg);
  color: var(--terminal-ink);
  font-family: var(--font-mono);
  font-size: 12px;
  line-height: 1.45;
  cursor: text;
}
.output {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 10px 12px 4px;
  white-space: pre-wrap;
}
.cmd {
  color: #cfd8b8;
}
.prompt {
  display: flex;
  gap: 8px;
  padding: 4px 12px 10px;
  color: #efdcb5;
}
.input {
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  padding: 0;
}
